// frontend/modules/document-type/index.ts
import { ModuleConfig } from '@/core/module';
import { documentTypeRoutes } from './routes';
import { useDocumentTypeStore } from './stores/document-type-store';

// Export hooks
export { useDocumentTypes } from './hooks/useDocumentTypes';
export { useDocumentTypeValidation } from './hooks/useDocumentTypeValidation';

// Export components
export { DocumentTypeForm } from './components/DocumentTypeForm';
export { DocumentTypeList } from './components/DocumentTypeList';
export { DocumentTypeCard } from './components/DocumentTypeCard';
export { DocumentTypeFilters } from './components/DocumentTypeFilters';
export { FileTypeSelector } from './components/FileTypeSelector';

// Export views
export { DocumentTypeManagementView } from './views/DocumentTypeManagementView';
export { DocumentTypeCreateView } from './views/DocumentTypeCreateView';
export { DocumentTypeEditView } from './views/DocumentTypeEditView';
export { DocumentTypeDetailView } from './views/DocumentTypeDetailView';

// Export types
export type { DocumentTypeFormData } from './types/document-type.types';

export const DocumentTypeModule: ModuleConfig = {
    name: 'document-type',
    routes: documentTypeRoutes,
    stores: {
        documentType: useDocumentTypeStore
    },
    initialize: () => {
        console.log('Document Type module initialized');
    }
};
